var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
var TrafficIcon = /** @class */ (function (_super) {
    __extends(TrafficIcon, _super);
    function TrafficIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TrafficIcon.prototype.render = function () {
        var _a = this.props, _b = _a.stroke, stroke = _b === void 0 ? '#979797' : _b, _c = _a.fill, fill = _c === void 0 ? 'none' : _c, other = __rest(_a, ["stroke", "fill"]);
        return (React.createElement("svg", __assign({ width: "44", height: "44", viewBox: "0 0 44 44", xmlns: "http://www.w3.org/2000/svg" }, other),
            React.createElement("g", { transform: "translate(8 10)", stroke: stroke, strokeWidth: "2", fill: fill, fillRule: "evenodd" },
                React.createElement("circle", { cx: "15", cy: "12", r: "12" }),
                React.createElement("path", { d: "M11.25 0C-6.125 0 2.768 15.75 2.768 12c0-6.627 5.372-12 12-12 6.627 0 12 5.372 12 12S22.55 0 11.25 0zm4.5 0H10.5h5.25z" }))));
    };
    return TrafficIcon;
}(PureComponent));
export default TrafficIcon;
